import { type FunctionComponent, type ReactNode } from 'react';
import { PlaceholderImage } from '../images/placeholder-image/placeholder-image.component';

export type LoadingWrapperProps = {
	isLoading: boolean;
	width?: number;
	height?: number;
	children: ReactNode;
	className?: string;
};

export const LoadingWrapper: FunctionComponent<LoadingWrapperProps> = ({ className = '', isLoading, width, height, children }) => {
	const classes = `br2 ${className}`;
	return isLoading ? <PlaceholderImage className={classes} width={width} height={height} /> : <>{children}</>;
};
